
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/flamingo/done",
      function () {
        return require("private-next-pages/download/flamingo/done/index.tsx");
      }
    ]);
  